"use client"
import { Container, FlexColumn } from "@opensea/ui-kit"
import { useSelectedLayoutSegments } from "next/navigation"

type MainContainerProps = {
  children: React.ReactNode
}

export function MainContainer({ children }: MainContainerProps) {
  return (
    <FlexColumn className="relative min-h-0 w-full min-w-0">
      {children}
    </FlexColumn>
  )
}

export function MainContentContainer({ children }: MainContainerProps) {
  const [_, topLevelSegment] = useSelectedLayoutSegments()
  const noContainerPaddingPages = [
    "stats",
    "activity",
    "chat",
    "careers",
    "jobs",
    "treasure",
  ]
  const shouldSkipContainer = noContainerPaddingPages.includes(topLevelSegment)
  return shouldSkipContainer ? children : <Container>{children}</Container>
}
